export const s3Upload = (url, buffer, mimeType) => {
  return fetch(url, {
    method: 'PUT',
    body: buffer,
    headers: {
      "Content-Type": mimeType
    }
  }).then(response => {
    if (!response.ok) {
      const error = new Error('An error occurred while fetching the data.')
      // Attach extra info to the error object.
      error.info = response.body
      error.status = response.status
      throw error
    }
  })
}